module.exports = __webpack_public_path__ + "static/media/primary-4.8c91a7a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primary-4.jpg
// module id = 155
// module chunks = 0